import produce from 'immer';
import { IKanbanState, TKanbanActions } from '../../types/redux/kanban';
import {
    MOVE_KANBAN_CARD, MOVE_KANBAN_CARD_TO_COLUMN, SET_KANBAN_CARDS, SET_KANBAN_DRAGGING_CARD,
} from '../actions/kanban';

const initialState: IKanbanState = {
    cards: [],
};

export const kanban = (state = initialState, action: TKanbanActions): IKanbanState => {
    switch (action.type) {
        case SET_KANBAN_CARDS: {
            return produce(state, (draft) => {
                draft.cards = action.pyload.cards;
            });
        }
        case MOVE_KANBAN_CARD: {
            return produce(state, (draft) => {
                const dragIndex = draft.cards.findIndex((el) => el.id === action.payload.targetId);
                const hoverIndex = draft.cards.findIndex((el) => el.id === action.payload.replaceId);

                if (draft.cards[dragIndex].column !== draft.cards[hoverIndex].column) {
                    draft.cards[dragIndex].column = draft.cards[hoverIndex].column;
                }

                const dragging = draft.cards.splice(dragIndex, 1);
                const moving = draft.cards.splice(action.payload.bottom ? hoverIndex + 1 : hoverIndex, draft.cards.length);

                draft.cards.push(...dragging);
                draft.cards.push(...moving);

                return draft;
            });
        }
        case MOVE_KANBAN_CARD_TO_COLUMN: {
            return produce(state, (draft) => {
                const dragIndex = draft.cards.findIndex((el) => el.id === action.payload.card);
                draft.cards[dragIndex].column = action.payload.column;
                return draft;
            });
        }
        case SET_KANBAN_DRAGGING_CARD: {
            return produce(state, (draft) => {
                draft.dragging = action.pyload.dragging ? action.pyload.card : undefined;
            });
        }
        default: {
            return state;
        }
    }
};
